import {channels, channelGroups, channelTypes} from '@divvit/common-channels'
import {countries} from 'countries-list/cjs'
import formatTimePeriodDate from 'utils/formatTimePeriodDate'

export const dateDimentions = ['date', 'month', 'week']

export default [
  {
    id: 'channelGroup',
    label: 'Channel Group',
    metricGroups: ['session', 'order', 'cost', 'customer', 'impression'],
    format: channelGoupId => channelGoupId && channelGroups[channelGoupId] && channelGroups[channelGoupId].label
  },
  {
    id: 'channel',
    label: 'Channel',
    metricGroups: ['session', 'order', 'cost', 'customer', 'impression'],
    format: channelId => channelId && channels[channelId] && channels[channelId].label
  },
  {
    id: 'device',
    label: 'Device',
    metricGroups: ['session', 'order'],
    format: val => {
      switch (val) {
        case 'mobile':
          return 'Mobile'
        case 'desktop':
          return 'Desktop'
        case 'tablet':
          return 'Tablet'
        default:
          return null
      }
    }
  },
  {
    id: 'channelType',
    label: 'Channel Type',
    metricGroups: ['session', 'order'],
    format: channelTypeId => channelTypes[channelTypeId || '']?.label
  },
  {
    id: 'country',
    label: 'Country',
    metricGroups: ['session', 'order'],
    format: code => countries[code.toUpperCase()]?.name || 'N/A'
  },
  {
    id: 'campaign',
    label: 'Campaign',
    metricGroups: ['session', 'order'],
    format: campaign => campaign || 'N/A'
  },

  {
    id: 'date',
    label: 'Date',
    metricGroups: ['session', 'order', 'cost', 'customer', 'impression'],
    format: (value) => formatTimePeriodDate('day', value)
  },

  {
    id: 'month',
    label: 'Month',
    metricGroups: ['session', 'order', 'cost', 'customer', 'impression'],
    format: (value) => formatTimePeriodDate('month', value)
  },

  {
    id: 'week',
    label: 'Week',
    metricGroups: ['session', 'order', 'cost', 'customer', 'impression'],
    format: (value) => value
  }

]



// WEBPACK FOOTER //
// ./client/utils/dimensions.js